import qs from 'qs'

import { HTTP } from './helpers/http'

export default {
  //Boards
  create(args = {}) {
    const { organizationId, data } = args
    return HTTP.post(`/api/v1/organizations/${organizationId}/boards/`, data)
  },

  update(args = {}) {
    const { organizationId, boardId, data } = args
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/boards/${boardId}`,
      data
    )
  },

  pin(organizationId, boardId) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/pins`
    )
  },

  unPin(organizationId, boardId) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/pins`
    )
  },

  delete(organizationId, boardId) {
    const url = `/api/v1/organizations/${organizationId}/boards/${boardId}`
    return HTTP.delete(url)
  },

  getStreamBoards(organizationId, options) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    return HTTP.get(`/api/v1/stream/${organizationId}/boards/`, params)
  },

  getAll(args = {}) {
    const {
      organizationId,
      relations = [],
      filters = {},
      sort = {},
      limit,
      skip,
      page,
      terms,
    } = args
    const params = {
      filters,
      relations,
      sort,
      skip,
      limit,
      page,
      terms,
    }

    return HTTP.get(`/api/v1/organizations/${organizationId}/boards/`, {
      params,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    })
  },

  getById(args = {}) {
    const { organizationId, boardId, relations = [] } = args

    const params = {
      relations,
    }

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/boards/${boardId}`,
      {
        params,
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      }
    )
  },

  //Columns

  createColumn(args = {}) {
    const { organizationId, boardId, data } = args
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/columns/`,
      data
    )
  },

  createColumnBulk(args = {}) {
    const { organizationId, boardId, columns } = args
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/columns/bulk`,
      { operation: 'post', data: columns }
    )
  },

  updateColumn(args = {}) {
    const { organizationId, boardId, columnId, data } = args
    return HTTP.put(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/columns/${columnId}`,
      data
    )
  },

  updateColumnBulk(args = {}) {
    const { organizationId, boardId, columns } = args
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/columns/bulk`,
      { operation: 'patch', data: columns }
    )
  },

  deleteColumn(organizationId, boardId, columnId) {
    const url = `/api/v1/organizations/${organizationId}/boards/${boardId}/columns/${columnId}`
    return HTTP.delete(url)
  },

  deleteColumnBulk(args = {}) {
    const { organizationId, boardId, columnIds } = args
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/columns/bulk`,
      { operation: 'delete', ids: columnIds }
    )
  },

  getColumns(args = {}) {
    const { organizationId, boardId, limit, relations = [], sort, skip } = args

    const params = {
      relations,
      sort,
      skip,
      limit,
    }

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/columns`,
      {
        params,
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      }
    )
  },

  getShareList(organizationId, boardId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/accounts`
    )
  },

  share(organizationId, boardId, users) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/accounts/bulk`,
      { operation: 'patch', data: users }
    )
  },

  removeShare(organizationId, boardId, usersIds) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/boards/${boardId}/accounts/bulk`,
      { operation: 'delete', ids: usersIds }
    )
  },

  unfollow(organizationId, boardId, userId) {
    const url = `/api/v1/organizations/${organizationId}/boards/${boardId}/accounts/${userId}`
    return HTTP.delete(url)
  },
}
